import Vue from 'vue';
import Vuex from "vuex";
import {results} from "./results";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        results
    }
});

store.subscribe((mutation, state) => {
    if(mutation.type.startsWith('results')) {
        sessionStorage.setItem('results', JSON.stringify(state.results));
    }
});

export default store;
